<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="hidden" name="stationed_id"></c-form-item>
					<c-form-item type="input" label="所属经销商" name="company_name" readonly @click="$refs.stationedSelector.open(2)"></c-form-item>
                    <c-form-item type="input" label="收支记录号" name="record_number"></c-form-item>
                    <c-form-item type="input" label="业务单号" name="docket_number"></c-form-item>
                    <c-form-item type="input" label="摘要" name="remark"></c-form-item>
                    <c-form-item type="select" label="账单类型" name="trans_type" :options="transType"></c-form-item>
                    <c-form-item type="input" label="收付渠道" name="trans_channel"></c-form-item>
                    <c-form-item type="select" label="收支类型" name="income_expenses" :options="incomeExpenses"></c-form-item>
                    <c-form-item type="datetime" label="交易时间" start-name="begin_time" end-name="end_time"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="checkbox" label="交易状态" name="trans_state" :options="transState" ></c-form-item>
				</c-form>
			</m-search>
			
			<!-- <m-operate>
				<c-button color="sys" power="b_stationed_account_record_export"  @click="exportJob()">导出</c-button>
			</m-operate> -->
			
			<c-table ref="table">
                <c-table-column
                        label="收支记录号"
                        name="record_number"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="经销商"
                        name="stationed_name"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="交易状态"
                        name="trans_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span style="color:green" v-if="data.trans_state==1">{{transStateName[data.trans_state]}}</span>
                        <span style="color:dodgerblue" v-if="data.trans_state==2">{{transStateName[data.trans_state]}}</span>
                        <span style="color:gray" v-if="data.trans_state==3">{{transStateName[data.trans_state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="会员手机号"
                        name="user_manage_mobilephone"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="会员头像/昵称"
                        name="head_photo"
                        width="140"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>


                <c-table-column
                        label="交易时间"
                        name="create_date"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="收支类型"
                        name="income_expenses"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span style="color:green" v-if="data.income_expenses==1">{{incomeExpensesName[data.income_expenses]}}</span>
                        <span style="color:red" v-if="data.income_expenses==2">{{incomeExpensesName[data.income_expenses]}}</span>
                        <span style="color:gray" v-if="data.income_expenses==3">{{incomeExpensesName[data.income_expenses]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="交易金额"
                        name="money"
                        width="100"
                >
                    <template v-slot="{data}">
                        <span>￥{{(data.money||0).toFixed(2)}}</span>
                    </template>
                </c-table-column>


                <c-table-column
                        label="交易摘要"
                        name="remark"
                        width="400"
                ></c-table-column>


                <c-table-column
                        label="业务单号"
                        name="docket_number"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="第三方支付单号"
                        name="third_number"
                        width="180"
                ></c-table-column>

                <c-table-column
                        label="分类"
                        width="80"
                        name="trans_classify"
                ></c-table-column>

                <c-table-column
                        label="账单类型"
                        name="trans_type"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="收付渠道"
                        name="trans_channel"
                        width="80"
                ></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="70"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/seller_account_record_detail/${data.id}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	export default {
		name: 'm_seller_account_record',
		
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
		props: {
			stationed_id: String,
			company_name: String
		},
		
		data() {
			return {
                transStateName: {
                    1: '交易成功',
                    2: '处理中',
                    3: '交易失败'
                },
                incomeExpensesName:{
                    1: '收入',
                    2: '支出'
                },
                incomeExpenses: [
                    {name: '收入',value: "1"},
                    {name: '支出',value: "2"}
                ],
                transState: [{
                    name: '交易成功',
                    value: 1
                },{
                    name: '处理中',
                    value: 2
                },{
                    name: '交易失败',
                    value: 3
                }
                ],
                transType: [,{
                    name: '订单消费',
                    value: "订单消费"
                },{
                    name: '订单退款',
                    value: "订单退款"
                },
                ]
			}
		},
		
		computed: {
			params() {
				return {
					stationed_id: this.stationed_id,
					company_name: this.company_name
				}
			}
		},
		
		watch: {
			params() {
				this.$refs.searchForm.clear();
				this.$refs.searchForm.set(this.params);
				this.$nextTick(() => {
					this.$refs.search.search();
				})
			}
		},
		
		mounted() {
			this.$refs.searchForm.set(this.params);
			this.$nextTick(() => {
				this.$refs.search.search();
			})
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 2;
				this.searchDate = data;
				this.$refs.table.load({
					url: '/user/account/record/list',
					data
				});
			},
			exportJob() {
        var data = this.searchDate;
        data.job_id = 16;
				this.request({
					url: '/export_job/add',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '导出任务提交成功，请稍后前往任务中心查看',
							icon: 'success'
						});
					}
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>